module.exports = __webpack_public_path__ + "img/string.c2996e9b.svg";